import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import downloadService from "../../services/DownloadService";

export const generateLink = createAsyncThunk(
  "download/generateLink",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await downloadService.generateLink(data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const download = createAsyncThunk(
  "download/download",
  async (token: any, { rejectWithValue }) => {
    try {
      const response = await downloadService.download(token);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
